<template>
  <el-dialog
    :visible.sync="NDAVisible"
    width="780px"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    custom-class="NDAdialog"
    center
    top="238px"
    :show-close="false"
  >
    <template slot="title">
      <div class="explain">
        <p>
          <i class="iconfont icon-error-circle-filled"></i>当前询盘需要你接受以下保密协议后，才能查阅图纸
        </p>
        <i class="iconfont icon-close cp" style="color: #999999;" @click="NDAVisible=false"></i>
        </div>
    </template>
    <div class="NDAtitle">保密协议</div>
    <div class="explainBody">
      <div>
        询盘RFQ为买方（个人或公司）所创建和发布，其中的所有数据和相关的图纸附件为买方的财产。
      </div>
      <div class="explainBodyitems">
        询盘RFQ中的所有信息代表着买方的专有信息，仅作为报价准备、工程审查、评估、设计、质量控制和/或接收检验的依据。未经买方书面同意，不得用于其他用途。
      </div>
      <div>
        点击下方“接受”按钮，等同于数字化签名并同意本保密协议。
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" class="acceptBtn" @click="accept">接受</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {applyOneNda} from "@/utils/api/zhenyunOrder"

export default {
  props:{
    id:{
      type:Number,
      default:0
    }
  },
  data() {
    return {
      NDAVisible: false,
    };
  },
  methods: {

    async accept(){
      const params={
        id:this.id
      }
      const res=await applyOneNda(params)
      if(res.rspResult.bizCode==200){
        this.$emit('changeDetails','agree',true)
        this.NDAVisible=false
      }
    }
  },
};
</script>
<style lang="scss" scoped>
:deep(.NDAdialog) {
  border-radius: 8px;
  font-family: SourceHanSansCN-Regular ;
  .NDAtitle {
    color: #222222;
    font-size: 18px;
    font-weight: 700;
    line-height: 28px;
    text-align: center;
    margin: 16px 0;
  }
  .el-dialog__header {
    padding: 0px;
    text-align: left;
  }
  .el-dialog__body{
    color: #222222;
    padding: 0px 24px 24px 24px;
  }
  .explain{
    padding:12px 24px;
    background: #FFF9ED;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    i{
      color: #FF7800;
      font-size: 16px;
      margin-right: 8px;
      font-weight: 400;
    }
    margin-bottom: 16px;
    font-size: 14px;
    line-height: 22px;
    color: #73451c;
  }
  .explainBody{
    color: #222222;
    font-size: 14px;
    line-height: 22px;
    .explainBodyitems{
      margin: 8px 0;
    }
  }
  .el-dialog__footer{
    padding-top: 0px;
  }
  .acceptBtn{
    background: #0863FF;
    color: #ffffff;
    border: none;
    width: 92px;
    height: 32px;
    font-size: 14px;
    font-weight: 400;
  }
  .acceptBtn:hover{
    background: #0863FF !important;
    border: none;
  }
}
.cp{
  cursor: pointer;
}
</style>